/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Group_CommercialInputs */

const en_reference_group_commercial = /** @type {(inputs: Reference_Group_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial terms`)
};

/**
* | output |
* | --- |
* | "Commercial terms" |
*
* @param {Reference_Group_CommercialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_group_commercial = /** @type {((inputs?: Reference_Group_CommercialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Group_CommercialInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_group_commercial(inputs)
});